import { Host, h } from "@stencil/core";
export class DnnSortIcon {
    constructor() {
        /** Defines the current sort direction */
        this.sortDirection = "none";
        this.focused = false;
    }
    changeSort() {
        switch (this.sortDirection) {
            case "asc":
                this.sortDirection = "desc";
                break;
            case "desc":
                this.sortDirection = "asc";
                break;
            case "none":
                this.sortDirection = "asc";
                break;
            default:
                break;
        }
        this.sortChanged.emit(this.sortDirection);
    }
    render() {
        return (h(Host, { key: '1f289964833f7c735887de5a8fd65091c91f9403', tabIndex: this.focused ? -1 : 0, onFocus: () => this.button.focus(), onBlur: () => this.button.blur() }, h("button", { key: 'aa3c23fcfc03535a3fdcccc01e2b6142f71ac0f5', ref: el => this.button = el, class: { "active": this.sortDirection != "none" }, onClick: () => this.changeSort(), onFocus: () => this.focused = true, onBlur: () => this.focused = false }, this.sortDirection == "none" &&
            h("svg", { key: '3eae289f7f69d8e3d2da7c58053c2ab94d3d4222', xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 12 16" }, h("path", { key: '90d60e5ac32d13f90949d74e36af3ffe2d9884ec', d: "M 0 7 H 12 L 6 0 Z M 0 9 H 12 L 6 16 Z" })), this.sortDirection == "asc" &&
            h("svg", { key: 'd3a5d9a62b844888963f9c795451255bb44f9056', xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 12 16" }, h("path", { key: 'c622ace2ea7177ea4480e9983cdb8e3ad425ea66', d: "M 0 7 H 12 L 6 0 Z" })), this.sortDirection == "desc" &&
            h("svg", { key: 'ceaef3f24f367870fb934890bfbd10b5ee71426f', xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 12 16" }, h("path", { key: 'db246c5f5b28c0f0606219cde513490e540a6073', d: "M 0 9 H 12 L 6 16 Z" })))));
    }
    static get is() { return "dnn-sort-icon"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["dnn-sort-icon.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["dnn-sort-icon.css"]
        };
    }
    static get properties() {
        return {
            "sortDirection": {
                "type": "string",
                "attribute": "sort-direction",
                "mutable": true,
                "complexType": {
                    "original": "\"asc\" | \"desc\" | \"none\"",
                    "resolved": "\"asc\" | \"desc\" | \"none\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Defines the current sort direction"
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "\"none\""
            }
        };
    }
    static get states() {
        return {
            "focused": {}
        };
    }
    static get events() {
        return [{
                "method": "sortChanged",
                "name": "sortChanged",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emitted when the sort is changed."
                },
                "complexType": {
                    "original": "\"asc\"|\"desc\"|\"none\"",
                    "resolved": "\"asc\" | \"desc\" | \"none\"",
                    "references": {}
                }
            }];
    }
}
//# sourceMappingURL=dnn-sort-icon.js.map
